"use client"

import styled from "@emotion/styled"
import FaqNew from "ui/FaqNew/FaqNew"

const StyledFaqWrapper = styled.div`
  .MuiAccordion-root {
    background: #ffffff !important;
  }

  .MuiAccordionSummary-root {
    background: #ffffff !important;
  }

  .MuiCollapse-root {
    background: #ffffff !important;
    border-color: #e6e6e6 !important;
  }

  .MuiTabs-root,
  .MuiTab-root,
  .MuiTypography-root,
  p,
  li,
  h3,
  h4 {
    color: #0b1b2b !important;
  }

  svg path {
    stroke: #0b1b2b !important;
  }
`

type Props = {
  data: any
}

function MasterAccordionFaq({ data }: Props) {
  return (
    <div data-master-faq>
      <StyledFaqWrapper>
        <FaqNew data={data} />
      </StyledFaqWrapper>
    </div>
  )
}

export default MasterAccordionFaq
